/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { resBreak } from '@/utils/resBreak';
import { SxProps } from '@mui/material';

export const headerNavBarContainerSX: SxProps = {
	borderRadius: 0,
	boxShadow: 0,
	borderBottom:'1px solid lightgrey',
	display: resBreak<'display'>({ mobile: 'none', tablet: 'block' , desktop:'block'}),
	backgroundColor: 'navbar.secondary',
	height:60,
	zIndex:1, //for 50 years logo change
};

export const headerNavBarLinkSX: SxProps = {
	flexDirection:'row',
	justifyContent:'space-between',
	fontSize:16,
	'$ > ': {
		textDecoration: 'none',
		'&:hover': {
			textDecoration: 'underline',
		}
	},
	'& > div, > nav ':{
		flexDirection:'row',
		justifyContent:'space-between',
		alignItems:'center',
		columnGap:resBreak<'column-gap'>({tablet:5, desktop:7})
	}
}

export const headerNavBarLinkMobSX: SxProps = {
	flexDirection:'column',
	alignItems:'flex-start',
	fontWeight:500,
	rowGap:2.5,
	mt:1,
}